/* eslint-disable no-throw-literal */
(() => {
  class BuyButton extends HTMLElement {
    constructor() {
      super();
      this.cartOpener = null;
      this.cartDrawer = null;
      this.buyButton = null;
      this.variantID = null;
      this.moduleClassification = null;
      this.queryID = null;
    }

    connectedCallback() {
      this.cartOpener = document.querySelector(".js-cart-drawer-opener");
      this.cartDrawer = document.querySelector("cart-drawer");
      this.buyButton = this.querySelector("button");
      this.variantID = this.getAttribute("data-variant-id");
      this.moduleClassification = this.getAttribute("data-module-classification");
      this.categories = this.getAttribute("data-item-categories");

      // Check for query ID from attribute or URL parameter
      this.queryID = this.getAttribute("data-queryid");
      if (!this.queryID) {
        const urlParams = new URLSearchParams(window.location.search);
        this.queryID = urlParams.get("queryID");
      }

      if (this.buyButton) {
        this.buyButton.addEventListener("click", async (e) => {
          e.preventDefault();
          const qty = this.getQuantity();
          this.addToCart(qty);
        });
      }
      if (this.parentElement.querySelector("quantity-selector")) {
        this.parentElement.addEventListener("changeQuantity", (e) => {
          if (e.target === this.parentElement.querySelector("quantity-selector")) {
            this.handleQuantityUpdate(e.detail.state);
          }
        });
      }
    }

    handleQuantityUpdate(state) {
      if (!state.hasCorrectQuantity) {
        // eslint-disable-next-line no-undef
        showErrorBox(state.message, this.parentElement, "buy-button__error-box--show", "buy-button__error-box--remove");
        const box = this.querySelector(".box");
        requestAnimationFrame(() => {
          setTimeout(() => {
            box.classList.add("buy-button__error-box--remove");
            box.classList.remove("buy-button__error-box--show");
          }, 3000);
        });
      }
    }

    getQuantity() {
      const minQuantity = parseInt(this.getAttribute("min-quantity"), 10);
      if (minQuantity > 1) {
        return minQuantity;
      }
      const qtySelector = this.parentElement.querySelector("quantity-selector");
      if (qtySelector) {
        return qtySelector.querySelector(".js-qty-input").value;
      }
      return 1;
    }

    async addToCart(qty) {
      this.cartOpener.click();
      this.querySelector(".loading__spinner")?.classList?.remove("hidden");
      this.buyButton.setAttribute("aria-disabled", true);

      // Check if quantity was clamped
      const qtySelector = this.parentElement.querySelector("quantity-selector");
      const quantityWarning = qtySelector?.getAttribute("data-quantity-clamped") === "true";
      const maxQty = qtySelector ? parseInt(qtySelector.querySelector(".js-qty-input")?.getAttribute("max"), 10) : null;

      const formData = {
        items: [
          {
            id: this.variantID,
            quantity: qty,
            properties: {
              _moduleClassification: this.moduleClassification,
              _categories: this.categories,
            },
          },
        ],
      };

      // Track Algolia add to cart event
      if (window.aa) {
        const price = parseFloat(this.getAttribute("data-price") || "0");

        // Store minimal data needed for purchase tracking
        const selectedRecord = {
          index: window.algoliaConfig.indexName,
          objectIDs: [this.variantID],
          ...(this.queryID && { queryID: this.queryID }),
          currency: window.algoliaConfig.currency || "EUR",
        };

        // Send appropriate event to Algolia
        if (this.queryID) {
          window.aa("addedToCartObjectIDsAfterSearch", {
            ...selectedRecord,
            eventName: "Product Added To Cart",
            objectData: [
              {
                price,
                quantity: parseInt(qty, 10),
              },
            ],
          });
        } else {
          window.aa("addedToCartObjectIDs", {
            ...selectedRecord,
            eventName: "Product Added To Cart",
            objectData: [
              {
                price,
                quantity: parseInt(qty, 10),
              },
            ],
          });
        }

        // Store the minimal record for purchase tracking
        try {
          const PURCHASE_STORAGE_KEY = "algolia_analytics_purchase_objects";
          const purchaseStorage = localStorage.getItem(PURCHASE_STORAGE_KEY);
          const purchaseObjects = purchaseStorage ? JSON.parse(purchaseStorage) : [];
          purchaseObjects.push(selectedRecord);
          localStorage.setItem(PURCHASE_STORAGE_KEY, JSON.stringify(purchaseObjects));
        } catch (error) {
          console.error("Failed to store purchase event:", error);
        }
      }

      this.cartDrawer.addToCart(formData, quantityWarning, maxQty).finally(() => {
        this.querySelector(".loading__spinner")?.classList.add("hidden");
        this.buyButton.setAttribute("aria-disabled", false);
      });
    }
  }

  customElements.define("buy-button", BuyButton);
})();
